export enum VipCategoryTypeModel {
    HIGH = "high",
    MEDIUM = "medium",
    LOW = "low"
}